<template>

    <div id="filterMenu"
         class="dd-m-menu dd-m-menu--modal dd-m-menu--filter dd-m-filter dd-m-filter--custom dd-m-filter--side">
        <div class="dd-m-menu__container">
            <button type="button" class="dd-m-menu__close-btn">
                <i class="dd-m-icon icon-close"></i>
            </button>

            <div class="dd-m-menu__header dd-m-filter--custom__header">
                <h2 class="dd-m-menu__title dd-m-filter--custom__title">
                    <i class="dd-m-icon icon-filter"></i>
                    {{getTranslateString('Filter')}}
                </h2>

                <span class="dd-m-helper--detail-row"></span>
            </div>

            <div class="dd-m-menu__content dd-m-filter--custom__content" v-if="results.length">
                <ul class="dd-m-filter--custom__list" 
                    v-for="(item, index) in results"
                    :key="index">
                    <li class="dd-m-filter--custom__item"
                        v-for="(subitem, subindex) in item.subcategories"
                        :key="subindex">

                        <input class="dd-m-filter--custom__checkbox"
                               :id="'field-'+ index +'-'+ subindex"
                               type="checkbox"
                               v-model="subitem.checked"
                               v-on:change="updateFilter()"/>

                        <label class="dd-m-filter--custom__label" :for="'field-'+ index +'-'+ subindex">
                            {{subitem.name}}
                        </label>

                    </li>
                </ul>
            </div>
        </div>

        <div class="dd-m-filter--custom__actions">
            <button type="button"
                    class="dd-m-button dd-m-button--big dd-m-button--light"
                    v-on:click.prevent="clear()">
                {{getTranslateString('Clear Filters')}}
            </button>

            <button type="button"
                    class="dd-m-button dd-m-button--big dd-m-button--light"
                    v-on:click.prevent="applyFilter()">
                {{getTranslateString('Filter')}}
            </button>
        </div>
    </div>

</template>
<script>
    import CategoryService from '../../providers/api/category-service';

    const bodyScrollLock = require('body-scroll-lock'),
        disableBodyScroll = bodyScrollLock.disableBodyScroll,
        enableBodyScroll = bodyScrollLock.enableBodyScroll,
        categoryService = new CategoryService();

    export default {
        name: 'card-filter',
        props: [],
        data: () => {
            return {
                results: []
            }
        },
        mounted() {
            PubSub.subscribe('toggleFilterMenu', () => this.toggle());
            PubSub.subscribe('closeFilterMenu', () => this.hide());
            this.getCategories();
        },
        methods: {
            toggle: () => {
                $('#filterMenu').fadeToggle('fast', () => {
                    if ($('body').hasClass('is-mobile')) {
                        if ($('#filterMenu').is(":visible")) {
                            disableBodyScroll(document.querySelector('#filterMenu'));
                            $('body').addClass('dd-b-hidden');
                        } else {
                            bodyScrollLock.clearAllBodyScrollLocks();
                            $('body').removeClass('dd-b-hidden');
                        }
                    }
                });
            },
            hide: () => {
                $('#filterMenu').fadeOut('fast');
                bodyScrollLock.clearAllBodyScrollLocks();
                $('body').removeClass('dd-b-hidden');
            },
            getCategories() {
                categoryService.doGetCategories()
                    .then((res) => {
                        res.data.data.map((item) => {
                            if (item.subcategories.length)
                                this.results.push(item);
                        });
                    });
            },
            search(){
                const checks = [];
                this.results.map(cat => cat.subcategories.filter(sub => sub.checked).map(f =>
                    checks.push(f)));
                const categories = checks.map((item) => item.slug).join();

                PubSub.publish('updateProductList', categories);
            },
            updateFilter() {
                if (window.innerWidth >= 768) {
                    this.search();
                }
            },
            clear() {
                this.results = this.results.map((item) => {
                    item.checked = false;
                    return item;
                });
            },
            applyFilter() {
                this.search();
                this.hide();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-filter.vue